export const tools = {
  strict: true, // true => strict update state from component

  state: {
    pageFocused: true,
    pageTitle: null,
    snackbar: null,
    path: null,
    randKey: randomHexString(16),
    help: true,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    windowScrollY: window.scrollY,
    tabYmAdjustHeight: 0,
    tabYmTouchEnd: { event: null, moving: false },
    yyyymm: 0,
    sortDialog: false,
    firebaseInitialized: false,
  },
  getters: {},

  mutations: {
    PAGE_FOCUSED: (state, payload) => {
      state.pageFocused = payload;
    },
    PAGE_TITLE: (state, payload) => {
      state.pageTitle = payload;
    },
    OPEN_SNACKBAR: (state, payload) => {
      state.snackbar = payload;
    },
    CLOSE_SNACKBAR: (state, payload) => {
      state.snackbar = null;
    },
    PATH: (state, payload) => {
      state.path = payload;
    },
    SET_HELP: (state, payload) => {
      state.help = payload;
    },
    SET_WINDOW_SIZE: (state, payload) => {
      state.windowWidth = window.innerWidth;
      state.windowHeight = window.innerHeight;
    },
    SCROLLED: (state, payload) => {
      state.windowScrollY = window.scrollY;
    },
    SET_TABYM_ADJUST: (state, payload) => {
      state.tabYmAdjustHeight = payload;
    },
    SET_TABYM_TOUCHEND: (state, payload) => {
      state.tabYmTouchEnd = payload;
    },
    SET_SORT_DIALOG: (state, b) => {
      state.sortDialog = b;
    },
    CURRENT_YM: (state, payload) => {
      state.yyyymm = payload;
    },
    FIREBASE_INITTED: (state, payload) => {
      console.log(`filebase initialized!`);
      state.firebaseInitialized = payload;
    },
  },
};
